import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function CheckedIcon(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path d="M9.00016 16.1701L4.83016 12.0001L3.41016 13.4101L9.00016 19.0001L21.0002 7.00009L19.5902 5.59009L9.00016 16.1701Z" />
    </IconWrapper>
  );
}
